// extracted by mini-css-extract-plugin
module.exports = {"btnClear":"ClearButton_btnClear__2WmGT"};